module.exports = __webpack_public_path__ + "static/media/materials_50k.8ae0284b.jpg";